import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary"
import TableReportHelper from "report/helper"

export default async function ReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor
    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null
    }

    let metaCliente = parseInt(params.meta)
    const chartSegments = [40, Number(metaCliente) - 4, parseInt(metaCliente), 100]

    async function getChart(conformidade) {
        return h.gaugeChart(
            {
                width: 200,
                height: 130,
                minValue: 40,
                maxSegmentLabels: 3,
                customSegmentStops: chartSegments,
                segments: 3,
                segmentsColors: ["#fe4719", "#ecdb23", "#6bd72d"],
                series: [{ name: "", values: conformidade }],
            },
            { alignment: "center", colSpan: 3 }
        )
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart)
}
